import { useUnit } from 'effector-react'
import { useEffect } from 'react'
import { smoothNavbarVisibilityFx } from '@/entities/navigation/effects'
import { $isNavVisible } from '@/entities/navigation/store'

export const useHideNav = (condition?: boolean) => {
  const isNavVisible = useUnit($isNavVisible)
  useEffect(() => {
    if (condition === undefined) {
      if (isNavVisible) smoothNavbarVisibilityFx(false)
    } else {
      if (isNavVisible && condition) {
        smoothNavbarVisibilityFx(false)
      }
      if (isNavVisible && !condition) {
        smoothNavbarVisibilityFx(true)
      }
    }

    return () => {
      smoothNavbarVisibilityFx(true)
    }
  }, [condition, isNavVisible])
}
